<template>
  <span class="inline-flex items-center relative" ref="wrapper">
    <button
      @click.stop="open = !open"
      class="inline-flex items-center justify-center w-7 h-7 rounded-full border border-gray-200 bg-white text-gray-400 hover:text-indigo-500 hover:border-indigo-300 hover:bg-indigo-50 shadow-sm transition-colors focus:outline-none"
      :class="{ 'text-indigo-500 border-indigo-300 bg-indigo-50': open }"
      aria-label="Help"
    >
      <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
      </svg>
    </button>
    <Teleport to="body">
      <div
        v-if="open"
        ref="popover"
        class="fixed z-[9999] bg-white border border-gray-200 rounded-lg shadow-lg p-3 w-72 text-xs text-gray-600 leading-relaxed"
        :style="popoverStyle"
      >
        <div v-if="title" class="font-semibold text-gray-800 text-xs mb-1">{{ title }}</div>
        <slot>{{ text }}</slot>
      </div>
    </Teleport>
    <!-- Backdrop to catch outside clicks -->
    <Teleport to="body">
      <div v-if="open" class="fixed inset-0 z-[9998]" @click="open = false"></div>
    </Teleport>
  </span>
</template>

<script setup>
import { ref, watch, nextTick, onBeforeUnmount } from 'vue'

defineProps({
  title: { type: String, default: '' },
  text: { type: String, default: '' }
})

const open = ref(false)
const wrapper = ref(null)
const popover = ref(null)
const popoverStyle = ref({})

const positionPopover = async () => {
  await nextTick()
  if (!wrapper.value || !popover.value) return

  const btn = wrapper.value.querySelector('button')
  if (!btn) return

  const rect = btn.getBoundingClientRect()
  const popEl = popover.value
  const popW = popEl.offsetWidth
  const popH = popEl.offsetHeight
  const pad = 8

  // Default: below the icon, left-aligned
  let top = rect.bottom + pad
  let left = rect.left

  // If overflows right edge, shift left
  if (left + popW > window.innerWidth - pad) {
    left = window.innerWidth - popW - pad
  }
  // If overflows left edge, shift right
  if (left < pad) left = pad

  // If overflows bottom, show above
  if (top + popH > window.innerHeight - pad) {
    top = rect.top - popH - pad
  }

  popoverStyle.value = {
    top: `${top}px`,
    left: `${left}px`
  }
}

watch(open, (val) => {
  if (val) positionPopover()
})

onBeforeUnmount(() => {
  open.value = false
})
</script>
